/* FENN: espelha as mensagens do formulário "Fale Conosco" (/pages/fale-conosco) pra Central de
 * Atendimento (20/09/2026, pedido do Leonardo: "o ideal é essas mensagens aparecerem em nosso painel
 * também"). NÃO troca o formulário nativo do Shopify por nada - ele continua enviando pro Shopify
 * normalmente (e-mail de notificação, captcha anti-robô, tudo como já era). Este script só ESCUTA o
 * envio e manda uma cópia, em paralelo, pra Central (api/site/contato), via navigator.sendBeacon
 * (sobrevive à troca de página que o envio nativo do Shopify causa - um fetch normal seria cancelado).
 * Só age na página /pages/fale-conosco; nenhuma outra página (inclusive /pages/contact) é afetada. */
(function () {
  // Usa o domínio vercel.app (confirmado funcionando em 20/09/2026) e não atendimento.fenn.com.br
  // (configurado no código da Central como padrão, mas sem DNS resolvendo nesta data) - trocar aqui
  // quando esse domínio próprio estiver de fato no ar.
  var ENDPOINT = 'https://fenn-atendimento.vercel.app/api/site/contato';

  function valor(form, campo) {
    var el = form.querySelector('[name="contact[' + campo + ']"]');
    return el ? el.value.trim() : '';
  }

  function ligar() {
    if (!document.querySelector("main[data-template='page.fale-conosco']")) return;
    document.querySelectorAll('form[id^="ContactForm-"]').forEach(function (form) {
      if (form.dataset.fennPainelLigado) return;
      form.dataset.fennPainelLigado = '1';
      form.addEventListener('submit', function () {
        var email = valor(form, 'email');
        var mensagem = valor(form, 'body');
        if (!email || !mensagem) return; // deixa a validação nativa do Shopify cuidar do resto
        var payload = JSON.stringify({ nome: valor(form, 'name'), email: email, mensagem: mensagem });
        try {
          if (navigator.sendBeacon) {
            navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'text/plain' }));
          } else {
            fetch(ENDPOINT, { method: 'POST', body: payload, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
          }
        } catch (e) {}
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar); else ligar();
  new MutationObserver(ligar).observe(document.documentElement, { childList: true, subtree: true });
})();
